document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.template-index .sm-reveal, .template-index [id$="featured_collection_NznQ8X"] .grid__item');

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach((item) => item.classList.add('sm-reveal--visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('sm-reveal--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px' });

  items.forEach((item, index) => {
    item.classList.add('sm-reveal');
    item.style.setProperty('--sm-reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);
    observer.observe(item);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sm-hero]').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('[data-sm-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-sm-hero-dot]'));
    const previous = hero.querySelector('[data-sm-hero-prev]');
    const next = hero.querySelector('[data-sm-hero-next]');
    const interval = Number(hero.dataset.autoplay) || 7000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;
    let touchStartX = 0;

    const showSlide = (index, restart = true) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.querySelectorAll('a, button').forEach((control) => {
          control.tabIndex = isActive ? 0 : -1;
        });
      });
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
      if (restart) startAutoplay();
    };

    const stopAutoplay = () => window.clearInterval(timer);
    const startAutoplay = () => {
      stopAutoplay();
      if (!reducedMotion && document.visibilityState === 'visible') {
        timer = window.setInterval(() => showSlide(activeIndex + 1, false), interval);
      }
    };

    previous?.addEventListener('click', () => showSlide(activeIndex - 1));
    next?.addEventListener('click', () => showSlide(activeIndex + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.smHeroDot))));
    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);
    hero.addEventListener('focusin', stopAutoplay);
    hero.addEventListener('focusout', (event) => {
      if (!hero.contains(event.relatedTarget)) startAutoplay();
    });
    hero.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    hero.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) > 55) showSlide(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') startAutoplay();
      else stopAutoplay();
    });

    showSlide(0);
  });
});
